module.exports = __webpack_public_path__ + "static/videoGameGif-502c5ad64b8c327897f0ede3cd1b5743.gif";